/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultStringDto } from '../../models/result-string-dto';

export interface UpdateCustomerHatcheryAvatar$Params {
  customerHatcheryId: number;
      body: {
}
}

export function updateCustomerHatcheryAvatar(http: HttpClient, rootUrl: string, params: UpdateCustomerHatcheryAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerHatcheryAvatar.PATH, 'post');
  if (params) {
    rb.path('customerHatcheryId', params.customerHatcheryId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResultStringDto>;
    })
  );
}

updateCustomerHatcheryAvatar.PATH = '/api/avatar/customerHatchery/{customerHatcheryId}';
